import React from 'react';
import { Card } from './ui/card';
import { 
  Brain, 
  BarChart3, 
  Code2, 
  Database, 
  FileSpreadsheet, 
  Sigma, 
  LineChart, 
  Presentation, 
  Sparkles,
  Network,
  Flame,
  Filter,
  Cloud
} from 'lucide-react';
import '../styles/Skills.css';

const iconMap = {
  'brain': Brain,
  'bar-chart-3': BarChart3,
  'code-2': Code2,
  'database': Database,
  'file-spreadsheet': FileSpreadsheet,
  'sigma': Sigma,
  'line-chart': LineChart,
  'presentation': Presentation,
  'sparkles': Sparkles,
  'network': Network,
  'flame': Flame,
  'filter': Filter,
  'cloud': Cloud
};

const Skills = ({ data }) => {
  const getIcon = (iconName) => {
    const IconComponent = iconMap[iconName] || Code2;
    return <IconComponent className="skill-icon" />;
  };

  return (
    <section id="skills" className="skills-section">
      <div className="skills-container">
        <div className="section-header">
          <h2 className="section-title">Skills & Technologies</h2>
          <p className="section-subtitle">
            Comprehensive toolkit for data-driven solutions
          </p>
        </div>

        <div className="skills-grid">
          {data.map((skill, index) => (
            <Card key={index} className="skill-card">
              <div className="skill-icon-wrapper">
                {getIcon(skill.icon)}
              </div>
              <h3 className="skill-name">{skill.name}</h3>
              <span className="skill-category">{skill.category}</span>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Skills;